function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { __DEV__, toSentenceCase } from "@thebouqs/utils";
import { BouqsCdnIcon } from "./bouqs-cdn-icon";
export var createBouqsCdnIcon = function createBouqsCdnIcon(icon, _temp) {
  var {
    displayName
  } = _temp === void 0 ? {} : _temp;

  var Component = props => {
    var {
      isProduction
    } = props,
        iconProps = _objectWithoutPropertiesLoose(props, ["isProduction"]);

    return /*#__PURE__*/React.createElement(BouqsCdnIcon, _extends({}, iconProps, {
      icon: icon,
      isProduction: isProduction
    }));
  };

  if (__DEV__) {
    Component.displayName = displayName != null ? displayName : toSentenceCase(icon) + "CdnIcon";
  }

  return Component;
};
//# sourceMappingURL=create-bouqs-cdn-icon.js.map